import { useMutation } from '@tanstack/react-query';
import { useRouter } from 'next/router';

import { useAppDispatch } from 'store';

import { $api, errorHandler, globalConst } from '../../global';
import { setPrivateTestData, startTimer } from '../store';

export const useStartPrivateTest = () => {
  const { push } = useRouter();
  const dispatch = useAppDispatch();

  return useMutation({
    mutationFn: async ({
      courseSlug,
      universitySlug
    }: {
      universitySlug?: string;
      courseSlug?: string;
      isExam?: boolean;
    }) => {
      const { data } = await $api.post('/private-order', {
        course_slug: courseSlug,
        university_slug: universitySlug
      });

      return data;
    },
    onSuccess: (data, variables) => {
      const { universitySlug, courseSlug, isExam = false } = variables;

      dispatch(setPrivateTestData(data));
      dispatch(startTimer(data));
      if (isExam) {
        push(
          `${globalConst.pageNames.EXAM}/${universitySlug}/${courseSlug}`
        );
      } else {
        push(
          `${globalConst.pageNames.PRIVATE_UNIVERSITIES}/${universitySlug}/${courseSlug}/test`
        );
      }
    },
    onError: errorHandler()
  });
};
